<div class="slow-toast">
  <img
    *ngIf="data.showMascot"
    class="slow-toast__mascot"
    src="assets/image/pawsper.png"
    alt=""
  />
  <div class="slow-toast__content">
    <ng-container *ngIf="data.anyReady; else noneReady">
      <div class="slow-toast__title">
        {{ "comparison.progress.slowSomeReadyTitle" | translate }}
      </div>
      <p>{{ "comparison.progress.slowSomeReadyDesc" | translate }}</p>
    </ng-container>
    <ng-template #noneReady>
      <div class="slow-toast__title">
        {{ "comparison.progress.slowNoneReadyTitle" | translate }}
      </div>
      <p>
        {{
          (data.waitingCount === 1
            ? "comparison.progress.slowNoneReadyDescOne"
            : "comparison.progress.slowNoneReadyDesc"
          ) | translate : { n: data.waitingCount }
        }}
      </p>
    </ng-template>
    <p>{{ "comparison.progress.slowRevisit" | translate }}</p>
  </div>
  <button
    type="button"
    class="slow-toast__close"
    [attr.aria-label]="'comparison.progress.close' | translate"
    (click)="snackBarRef.dismiss()"
  >
    <svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true">
      <path
        d="M6 6l12 12M18 6L6 18"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
      />
    </svg>
  </button>
</div>
